import axios from "axios";
import Config from "../Config";
import { getFromLocalStorage } from "../libs/helpers/localstorage";

// Consent step of the MCP OAuth flow (see backend/src/api/mcpOauth.api).
// Not specific to a single MCP server: the backend decides who may approve what.

function authConfig() {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  return {
    headers: {
      Authorization: `Bearer ${ls && ls.token}`,
      "x-tenant": tenant,
    },
  };
}

const requestUrl = (id, action = "") =>
  `${Config.apiBaseurl}/api/v1/mcp-oauth/requests/${encodeURIComponent(
    id,
  )}${action}`;

export async function getMcpAuthorizationRequestApi(id) {
  const res = await axios.get(requestUrl(id), authConfig());
  return res.data;
}

// Both resolve to { redirectUrl }: where to send the browser next (the client's redirect URI)
export async function approveMcpAuthorizationRequestApi(id) {
  const res = await axios.post(requestUrl(id, "/approve"), {}, authConfig());
  return res.data;
}

export async function denyMcpAuthorizationRequestApi(id) {
  const res = await axios.post(requestUrl(id, "/deny"), {}, authConfig());
  return res.data;
}
